// START Script to control in-line grid modal
// Get the modal
var modal = document.getElementById("in-line-grid-modal");

// Get the button that opens the modal
var btn = document.getElementById("in-line-grid-promo");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal


document.getElementById("in-line-grid-promo").addEventListener("click", function(event){
  event.preventDefault()
    modal.style.display = "block";
});

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
// END Script to control in-line grid modal